import { i18n } from '@vestico/i18n';

export const i18nCancelButtonTitle = () => i18n.t('LOC_CANCEL_BUTTON', { ns: 'shared' });
export const i18nBackButtonTitle = () => i18n.t('LOC_BACK_BUTTON', { ns: 'shared' });
export const i18nNextButtonTitle = () => i18n.t('LOC_NEXT_BUTTON', { ns: 'shared' });
export const i18nApplyButtonTitle = () => i18n.t('LOC_APPLY_BUTTON', { ns: 'shared' });
